






import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Icon extends Vue {
  @Prop()
  for: string;

  @Prop()
  type: string;

  get whatToUse(): string {
    return this.for || this.type;
  }

  get wrapperClasses(): string {
    return `icon-wrapper ${this.whatToUse}-icon-wrapper`;
  }

  get classes(): string {
    return `icon ${this.whatToUse}-icon`;
  }

  get icon() {
    return require(`../../public${this.path}`); // eslint-disable-line
  }

  get path(): string {
    return `/icons/${this.whatToUse}.svg`;
  }

  get alt(): string {
    return `Icon for ${this.whatToUse}`;
  }
}
